import React from 'react';
import { Uses } from '../../components/layout/Uses';

const UsesView = () => {
  return (
    <div>
      <Uses />
    </div>
  );
};

export default UsesView;
